<template>
  <div class="row no-gutters checkout-container">
    <section class="col-lg-4 order-lg-last order-summary-container">
      <order-summary></order-summary>
    </section>

    <section class="col-lg-8 order-lg-first order-details-container">
      <div class="section-heading">
        <h3>Checkout</h3>
      </div>

      <div class="order-details" v-if="show_login">
        <div class="login-form">
          <label class="section-label">Login</label>
          <p>A customer already exists with your email address. Please login to complete this order.</p>
          <vue-login></vue-login>
        </div>
      </div>

      <div class="order-details" v-if="!show_login">
        <vue-address-details
          :details.sync="delivery.address"
          @updated:address="updateDeliveryAddress"
          type="Delivery"
          :getInstructions="true"
          errorMessage="Street Address is required. Please type the street address where you would like the SIM/s delivered."
        ></vue-address-details>

        <div class="payment-options">
          <label class="section-label">Debit Order Details</label>

          <div class="payment-option-details form-group">
            <vue-bank-details :details="payment_details.bank_details"></vue-bank-details>
          </div>

          <label class="section-label">Promotions</label>
          <div class="form-group">
            <input
              type="text"
              name="promo_code"
              v-model="promo_code"
              class="form-control"
              placeholder="Promo Code"
            >
          </div>
        </div>

        <div class="complete-error" v-if="has_error">{{ message }}</div>
      </div>
    </section>
  </div>
</template>


<script>
import store from "@/store";
import EventBus from "@/components/shared/event-bus";
import OrderService from "@/services/order.service.js";
import CustomerService from "@/services/customer.service.js";

import DeliveryModel from "@/models/delivery.model";
import PaymentDetailsModel from "@/models/payment-details.model";
import AddressModel from "@/models/address.model";

import VueLogin from "@/components/elements/vue-login";
import VueAddressDetails from "@/components/elements/vue-address-details";
import OrderSummary from "./order-summary.vue";
import VueBankDetails from "@/components/elements/vue-bank-details.vue";

import { mapGetters } from "vuex";

import { CART_RESET } from "@/store/actions.type";

export default {
  name: "order-details",
  components: {
    "order-summary": OrderSummary,
    "vue-bank-details": VueBankDetails,
    "vue-address-details": VueAddressDetails,
    "vue-login": VueLogin
  },
  computed: {
    ...mapGetters(["currentStep", "cart", "isAuthenticated", "currentUser"]),
    displayBack() {
      return this.currentStep > 0;
    }
  },
  watch: {
    isAuthenticated(value, oldValue) {
      var self = this;

      //Set address if user logs in
      if (value && self.currentUser) {
        self.delivery.address = new AddressModel(self.currentUser.address);
        self.show_login = false;
      }

      //Reset address if user logs out.
      if (!value && oldValue) {
        self.clearAddressForm();
      }
    }
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
    if (self.isAuthenticated && self.currentUser) {
      self.delivery.address = new AddressModel(self.currentUser.address);
    } else {
      var emails = [];
      self.cart.sims.forEach(sim => {
        emails.push(sim.subscriber.email_address);
      });
      self.validateEmailExists(emails);
      if (self.cart.sims.length > 0)
        self.username = self.cart.sims[0].subscriber.email_address;
    }
    self.registerListeners();
  },
  data: function() {
    return {
      delivery: new DeliveryModel(),
      show_login: false,
      has_error: false,
      promo_code: "",
      message: "",
      payment_details: new PaymentDetailsModel(),
      banks: [],
      accepted_terms: false,
      username: "",
      password: false,
      keep_in_touch: false
    };
  },
  methods: {
    payNow() {
      var self = this;
      if (!self.delivery.address.is_valid) return false;
      self.$validator.validateAll().then(success => {
        EventBus.$emit("global_loading", {
          is_loading: true,
          loading_message: "Processing Request..."
        });
        self.delivery.is_required = self.cart.delivery.is_required;
        self.$log.debug(
          "Payment request",
          self.payment_details.payment_option_type
        );
        //Payment Request. Login & Redirect to payment on success.
        OrderService.simOrder(
          self.delivery,
          self.payment_details,
          self.promo_code,
          self.cart.sims
        )
          .then(function(response) {
            self.$log.debug("SIM order request response", response);
            var r = response.data;

            if (r.success) {
              self.has_error = true;
              self.message = "Order successfully created. Please reset below.";
              store.dispatch(CART_RESET);
              self.$router.push("call-centre-complete");
            }
            EventBus.$emit("global_loading", { is_loading: false });
          })
          .catch(function(error) {
            EventBus.$emit("global_loading", { is_loading: false });
            self.has_error = true;
            self.message =
              "We could not process your order. Please contact support for further assistance.";
            if (
              !self.isEmpty(error.response) &&
              !self.isEmpty(error.response.data)
            ) {
              self.message = error.response.data.message;
            }
            self.$log.error("Error requesting payment", error);
          });
        return success;
      });
    },
    updateDeliveryAddress(address) {
      var self = this;
      self.delivery.address = address;
    },
    isEmpty(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    validateEmailExists(emails) {
      var self = this;
      CustomerService.exists(emails).then(function({ data }) {
        var response = data;
        self.$log.debug("Customer exists response", response);
        if (response.success && response.data) {
          self.$log.debug("Customer exists");
          self.show_login = true;
        }
      });
    },
    userAuthenticated(state) {
      self.show_login = !(state && self.show_login);
    },
    registerListeners() {
      var self = this;
      EventBus.$on("validate:checkout", function() {
        self.payNow();
      });
    }
  }
};
</script>